<template>
  <div class="lottery-animate">
    <div class="container">
      <div class="coach-info">
        <div class="info" v-if="coachInfo">
          <img class="avatar" :src="coachInfo.coach_img" alt="" />
          <div class="truename">{{ coachInfo.coach_name }}</div>
        </div>
        <img
          class="image"
          src="https://btw-common-data.betterwestar.com/btw-admin/resource/b6ed43964880c1623dd93f2c637d4011_wh=1068_232.png"
          alt=""
        />
      </div>
      <div ref="lottieIcon" class="lottie-icon"></div>
    </div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    coachInfo() {
      return this.$store.state.coachActivity2024.lotteryAnimate.coachInfo
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.play()
      }
    }
  },
  mounted() {
    this.lottie = lottie.loadAnimation({
      container: this.$refs.lottieIcon, // the dom element that will contain the animation
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: 'https://gymvue.gymcity.com.cn/betterwe_app/2024%E5%81%A5%E8%90%8C%E6%95%99%E7%BB%83%E6%B4%BB%E5%8A%A8.json' // the path to the animation json
    })
    this.lottie.addEventListener('complete', this.completeAnimate)
  },
  methods: {
    completeAnimate() {
      this.lottie.goToAndStop(0)
      this.$emit('close')
    },
    play() {
      this.lottie.play()
    }
  }
}
</script>
<style scoped lang="scss">
.lottery-animate {
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .container {
    position: relative;
    .coach-info {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      position: absolute;
      left: 50%;
      top: 9px;
      transform: translate(-50%, -100%);
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      line-height: 25px;
      .info {
        margin-bottom: 13px;
        display: flex;
        align-items: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .truename {
        max-width: 200px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .avatar {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
        margin-right: 4px;
      }
      .image {
        width: 267px;
        height: 58px;
        object-fit: contain;
      }
    }
  }
  .lottie-icon {
    width: 311px;
    height: 233px;
  }
}
</style>
